






















import Vue from 'vue';
import { commonProps } from '~/utils/candidate';
import SummaryModal from '../modals/SummaryModal.vue';
import Card from './Card.vue';

export default Vue.extend({
    name: 'Summary',
    components: {
        Card,
        SummaryModal,
    },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        hasNoSummary(): boolean {
            return (this.candidate.summary || '').length === 0;
        },
        cardTitle(): string {
            return this.hasNoSummary
                ? (this.$t('profile.summary.titleWhenEmpty') as string)
                : (this.$t('profile.summary.title') as string);
        },
    },
    methods: {},
    mounted() {},
});
